import commonsApi from '@/api/commons'
export default {
  methods: {
    async getAllLmSuperPowerSelectOptions (lmSuperPowerSelectOptionsSettings) {
      let myArray = lmSuperPowerSelectOptionsSettings.map(
        element => {
          const promise = new Promise(async function (resolve, reject) {
            const newElement = {}
            newElement.name = element.name
            newElement.tbColumns = element.tbColumns || ''
            newElement.data = await commonsApi.getSelectOptions(element.obj)
            resolve(newElement)
            reject(new Error('Error con ' + newElement.name))
          })
          return promise
        })
      return Promise.all(myArray)
    },
    sanitizeModel (model) {
      return model ? model.toString() : ''
    }
  }
}
